import styled from 'styled-components';

export const ContainerGeral = styled.div`
	display: contents;
	justify-content: center;
	overflow: auto;
	align-items: center;
	min-height: 300px;
	width: 100%;
`;

export const Text = styled.h3`
	display: flex;
	justify-content: center;
	height: 100%;
	width: 100%;
`;
